import { render, staticRenderFns } from "./PhotoCarousel.vue?vue&type=template&id=485997b0&scoped=true&"
import script from "./PhotoCarousel.vue?vue&type=script&lang=js&"
export * from "./PhotoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCarousel.vue?vue&type=style&index=0&id=485997b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485997b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VDialog,VRow})
